import alerts from "./alerts.json";
import form from "./form.json";

const RoomLikeAndFeatureConfig = {
    alerts,
    form,
};

export default RoomLikeAndFeatureConfig;